export class InventoryDtoResponse {
  onHandQtyMtl: number;
  onHandQtyCal: number;
  onHandQtyPic: number;
  onHandActualQtyMtl: number;
  onHandActualQtyCal: number;
  onHandActualQtyPic: number;
  onOrderQtyMtl: number;
  inTransitQtyCal: number;
  inTransitQtyPic: number;
  onOrderETAMtl: string;
  inTransitETACal: string;
  inTransitETAPic: string;
  procurementLeadTime: string;
  mtl3PLStockQty: number;
  mtl3PLBlankStockQty: number;

  // ***** On Order/ETA ***** //
  onOrderAvailQtyMTL: number;
  onOrderAvailQtyCAL: number;
  onOrderAvailQtyPIC: number;
  expectedDateMTL: string;
  expectedDateCAL: string;
  expectedDatePIC: string;

  procurementTypeCode: string;

  constructor() {
    this.onHandQtyMtl = 0;
    this.onHandQtyCal = 0;
    this.onHandQtyPic = 0;
    this.onHandActualQtyMtl = 0;
    this.onHandActualQtyCal = 0;
    this.onHandActualQtyPic = 0;
    this.onOrderQtyMtl = 0;
    this.inTransitQtyCal = 0;
    this.inTransitQtyPic = 0;
    this.onOrderETAMtl = "";
    this.inTransitETACal = "";
    this.inTransitETAPic = "";
    this.mtl3PLStockQty = 0;
    this.mtl3PLBlankStockQty = 0;

    // ***** On Order/ETA ***** //
    this.onOrderAvailQtyMTL = 0;
    this.expectedDateMTL = null;
    this.onOrderAvailQtyCAL = 0;
    this.expectedDateCAL = null;
    this.onOrderAvailQtyPIC = 0;
    this.expectedDatePIC = null;

    this.procurementLeadTime = null;
    this.procurementTypeCode = null;
  }
}

export class InventoryDetailDtoResponse {
  label: string;
  qty: number;
  showTopBorder: boolean;
  showBottomBorder: boolean;

  constructor() {
    this.label = "";
    this.qty = 0;
    this.showTopBorder = false;
    this.showBottomBorder = false;
  }
}
